module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 16.6 16.6",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#arrow-usage",
      toString: function () {
        return this.url;
      }
    }